import React from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const CancelProcessModal = ({ isOpen, redirectUrl, onClose }) => {
  const handleOnClose = () => {
    onClose();
  };

  const handleBack = () => {
    window.location.replace(redirectUrl);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="cancel-process" data-testid="cancel-process-content">
        <h3 className="title">You are in the middle of an order</h3>
        <div className="paragraph">
          Are you sure you want to quit your stack analysis order?
        </div>
        <div className="action-buttons">
          <Button
            type="solid"
            color="green"
            label="Yes and discard my changes"
            block
            onClick={handleBack}
          />
          <Button
            type="outlined"
            color="white"
            label="No, keep going"
            block
            onClick={handleOnClose}
          />
        </div>
      </div>
    </CustomModal>
  );
};

CancelProcessModal.propTypes = {
  farmInfo: PropTypes.shape({
    farm_id: PropTypes.number.isRequired,
    farm_name: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

CancelProcessModal.defaultProps = {
  redirectUrl: "",
};

export default CancelProcessModal;
